import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Tab } from 'semantic-ui-react';
import ChartCompareContent from './ChartCompareContent';

import styles from './Report.module.scss';

const Report = React.memo(
  ({
    items,
    dailyReport,
    monthlyReport,
    yearlyReport,
    onChangeDaily,
    onChangeMonthly,
    onChangeYearly,
  }) => {
    const [t] = useTranslation();

    const panes = [
      {
        menuItem: t('common.reports.day'),
        render: () => (
          <Tab.Pane>
            <ChartCompareContent
              type="daily"
              items={items}
              reports={dailyReport}
              onChangeDate={onChangeDaily}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: t('common.reports.month'),
        render: () => (
          <Tab.Pane>
            <ChartCompareContent
              type="monthly"
              items={items}
              reports={monthlyReport}
              onChangeDate={onChangeMonthly}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: t('common.reports.year'),
        render: () => (
          <Tab.Pane>
            <ChartCompareContent
              type="yearly"
              items={items}
              reports={yearlyReport}
              onChangeDate={onChangeYearly}
            />
          </Tab.Pane>
        ),
      },
    ];

    return (
      <div className={styles.devicesWrapper}>
        <h2 className="page-title">{t('common.report')}</h2>
        <Tab panes={panes} />
      </div>
    );
  },
);

Report.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  dailyReport: PropTypes.objectOf(PropTypes.any).isRequired,
  monthlyReport: PropTypes.objectOf(PropTypes.any).isRequired,
  yearlyReport: PropTypes.objectOf(PropTypes.any).isRequired,
  onChangeDaily: PropTypes.func.isRequired,
  onChangeMonthly: PropTypes.func.isRequired,
  onChangeYearly: PropTypes.func.isRequired,
};

export default Report;
